var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6125 2.7875L7.37506 5.12499C5.93756 5.66249 4.76257 7.36248 4.76257 8.89998V18.1875C4.76257 19.6625 5.73758 21.6 6.92508 22.4875L12.3001 26.5C14.0626 27.825 16.9625 27.825 18.725 26.5L24.1001 22.4875C25.2876 21.6 26.2625 19.6625 26.2625 18.1875V8.89998C26.2625 7.36248 25.0875 5.66249 23.65 5.12499L17.4126 2.7875C16.3501 2.4 14.65 2.4 13.6125 2.7875Z",
    stroke: "#101010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 13.65C15.4501 13.65 15.3876 13.65 15.3376 13.65C14.1626 13.6125 13.2251 12.6375 13.2251 11.45C13.2251 10.2375 14.2126 9.25 15.4251 9.25C16.6376 9.25 17.6251 10.2375 17.6251 11.45C17.6126 12.65 16.6751 13.6125 15.5001 13.65Z",
    stroke: "#101010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0126 17.15C11.8126 17.95 11.8126 19.2625 13.0126 20.0625C14.3751 20.975 16.6126 20.975 17.9751 20.0625C19.1751 19.2625 19.1751 17.95 17.9751 17.15C16.6251 16.2375 14.3876 16.2375 13.0126 17.15Z",
    stroke: "#101010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityUser);
export default __webpack_public_path__ + "static/media/security-user.fe05cde09d22e155507119b95aaddf7a.svg";
export { ForwardRef as ReactComponent };